<template>
  <div class="onboarding-container settlements-form-container">
    <div class="sidebar" v-if="!readOnly">
      <ul class="menu" v-scroll-spy-active="{class: 'custom-active'}" v-scroll-spy-link="{selector: '.menu-item'}">
        <li :key="item" v-for="item in titles" class="menu-item" :id="getElementId('nav_menu_item-' + item)">
          <a>{{ item }}</a>
        </li>
      </ul>
    </div>

    <div class="main" :class="{'no-scroll-spy': readOnly}" v-scroll-spy="{offset: 150, time: 100}">
      <div class="section-one">
        <AdditionalUnderwritingData />
      </div>
      <div class="section-two">
        <BankAccountForPayout
          :read-only="readOnly"
        />
      </div>
      <div class="agreement">
        {{ $t('bankAccountForPayouts.agreement') }}
      </div>
      <div class="next-step">
        <c-button
          @click="prev"
          size="large"
          class="c-mt--xxl c-mb--xxl"
        >
          {{ $t('global.action.prevStep') }}
        </c-button>
        <c-button
          @click="onSubmit"
          variant="primary"
          size="large"
          v-if="!readOnly"
          class="c-mt--xxl c-mb--xxl"
        >
          {{ $t('global.action.submit') }}
        </c-button>
      </div>
    </div>
  </div>
</template>

<script>
import BankAccountForPayout from "@/components/onboarding/BankAccountForPayout.vue";
import AdditionalUnderwritingData from "@/components/onboarding/AdditionalUnderwritingData.vue"
import {mapActions, mapGetters, mapState} from "vuex";
import FullStoryHelper from '@/app/utils/fullstory';
import { TRANSACTION_SETTLEMENT_PAGE } from '@/app/utils/fullstory/constants';
import {PendoPrefixes} from "@/app/utils/common/constants";

export default {
  name: "SettlementsForm",
  components: {
    AdditionalUnderwritingData,
    BankAccountForPayout
  },
  props: {
    onSubmit: {
      type: Function,
      required: true
    },
    prev: {
      type: Function,
      required: true
    },
    generateErrors: {
      type: Function,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      titles: [
        this.$t('additionalUnderwritingData.title'),
        this.$t('bankAccountForPayouts.title'),
      ]
    }
  },
  computed: {
    ...mapGetters('app', ['isAdminMode', 'getMerchantId']),
    ...mapState({
      bankAccountForPayouts: state => state.bankAccountForPayouts,
    }),
  },
  mounted() {
    FullStoryHelper.event(TRANSACTION_SETTLEMENT_PAGE);
  },
  methods: {
    ...mapActions('bankAccountForPayouts', {
      validateBankAccountForPayouts: 'validate',
    }),
    ...mapActions('additionalUnderwritingData', {
      validateAdditionalUnderwritingData: 'validate',
    }),
    getElementId(id) {
      return PendoPrefixes.CBpay + this.$route.name + '-' + id.toLowerCase().replace(/\s+/g, '_');
    }
  },
}

</script>

<style src="@/app/assets/style/onboarding-form.scss" lang="scss"></style>